module.exports = __webpack_public_path__ + "static/scale-model-of-etherton-gallery-in-tucson-arizona-4d13d81d1f2e069083d322d0f2d75745.png";